<template>
  <AuthTemplate type="register">
    <h1>Регистрация</h1>
    <div>
      <div style="margin-bottom: 20px">
        <custom-input placeholder="Номер телефона" input_type="phone" v-model="form.phone" @change="() => errors.phone = null"/>
        <error-text :text="errors.phone"/>
      </div>
<!--      <div style="display: flex; align-items: center">-->
<!--        <custom-checkbox v-model="terms"  @change="() => errors.terms = null"/>-->
<!--        <span>Я принимаю <a class="terms-link" target="_blank" href="/terms">условия пользовательского соглашения</a></span>-->
<!--      </div>-->
<!--      <div style="margin-bottom: 20px">-->
<!--        <error-text :text="errors.terms"/>-->
<!--      </div>-->
      <button-component
          mb="30px"
          variant="filled"
          @click="send()"
      >Подтвердить номер
      </button-component>
    </div>
  </AuthTemplate>
</template>

<script>
import AuthTemplate from '../../../templates/AuthTemplate'
import CustomInput from '../../../components/ui/inputs/custom-input'
import ButtonComponent from '../../../components/ui/buttons/button-component'
import {mapMutations} from 'vuex'
import ErrorText from "@/components/ui/text/error-text";

export default {
  name: 'Register_Client',
  components: { ButtonComponent, CustomInput, AuthTemplate, ErrorText},
  data() {
    return {
      terms: true,
      form: {
        type: 'client',
        code: '',
      },
      errors: {},
    }
  },
  mounted() {
    this.form.code = this.$route.params.code ? this.$route.params.code : '';
  },
  methods: {
    ...mapMutations(['openModal', 'setRegisterData']),
    send() {
      if(this.terms){
        const prevPhone = this.form.phone
        try{
          const phone = parseInt(this.form.phone.replace(/\D+/g,""))
          this.form.phone = `+${phone}`
        } catch (e){
          return this.$set(this.errors, 'phone', ['Заполните это поле'])
        }

        this.$api.auth.register.create(this.form)
            .then(({data}) => {
              this.setRegisterData(data);
              this.openModal('register_confirm')
            }).catch(({response}) => {
          this.form.phone = prevPhone
          this.errors = response.data.errors
        });
      }else{
        this.errors = { terms: ['Вы должны принять условия'] };
      }

    },
  }
}
</script>

<style scoped>
.terms-link{
  cursor: pointer;
  color: #b97860;
}
.terms:hover{
  color: #dbbfa7;
  transition: .3s;
}
</style>
